module.exports = __webpack_public_path__ + "img/viblo-interview.f10e6b69.png";